import { useState } from "react";
import { CheckSquare, Printer, Square } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

/** Pilihan cetak STB: keseluruhan atau hanya marking terpilih (dokumen berlabel PARSIAL) */
export function StbPrintPicker({ stb, onPrint, onClose, preselect = [] }) {
  const rows = stb?.markings || [];
  const [mode, setMode] = useState(preselect.length ? "partial" : "all");
  const [sel, setSel] = useState(preselect.length ? preselect : rows.map((r) => r.id));
  if (!stb) return null;
  const toggle = (id) => setSel(sel.includes(id) ? sel.filter((x) => x !== id) : [...sel, id]);
  const picked = mode === "all" ? rows : rows.filter((r) => sel.includes(r.id));
  const go = () => onPrint({ ...stb, markings: picked, partial: mode === "partial" && picked.length < rows.length, partialInfo: `${picked.length} dari ${rows.length} marking` });
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl bg-[#0D1524] border-slate-800" data-testid="stb-print-picker">
        <DialogHeader><DialogTitle className="font-display text-slate-100">Cetak STB <span className="font-mono text-sky-300">{stb.no}</span> <span className="cn text-sm font-normal text-slate-500">打印交接单</span></DialogTitle></DialogHeader>
        <div className="flex gap-2 text-xs" data-testid="stb-print-mode">
          {[["all", `Keseluruhan (${rows.length} marking)`], ["partial", "Per marking terpilih — berlabel PARSIAL"]].map(([k, t]) => (
            <button type="button" key={k} onClick={() => setMode(k)} className={`rounded border px-3 py-1.5 ${mode === k ? "border-sky-500/60 bg-sky-500/10 text-sky-300" : "border-slate-800 text-slate-400 hover:border-slate-600"}`} data-testid={`stb-print-mode-${k}`}>{t}</button>
          ))}
        </div>
        {mode === "partial" && (
          <div className="max-h-72 overflow-y-auto rounded border border-slate-800" data-testid="stb-print-marking-list">
            <div className="flex items-center gap-2 border-b border-slate-800 bg-[#0B1322] px-2 py-1.5 text-[11px]">
              <button type="button" onClick={() => setSel(rows.map((r) => r.id))} className="text-sky-300 hover:underline" data-testid="stb-print-select-all">Pilih semua</button>
              <button type="button" onClick={() => setSel([])} className="text-slate-400 hover:underline" data-testid="stb-print-select-none">Kosongkan</button>
              <span className="ml-auto font-mono text-slate-400">{sel.length} dipilih</span>
            </div>
            {rows.map((r) => (
              <button type="button" key={r.id} onClick={() => toggle(r.id)} className={`flex w-full items-center gap-2 border-t border-slate-800/60 px-2 py-1.5 text-left text-xs hover:bg-slate-800/40 ${sel.includes(r.id) ? "bg-sky-500/5" : ""}`} data-testid={`stb-print-pick-${r.code}`}>
                {sel.includes(r.id) ? <CheckSquare className="h-4 w-4 text-sky-400" /> : <Square className="h-4 w-4 text-slate-500" />}
                <span className="font-mono text-amber-400">{r.code}</span>
                <span className="text-slate-400">{r.profile || ""}</span>
                <span className="ml-auto font-mono text-slate-300">{r.qty} pcs · approved {r.approved ?? r.realisasi ?? 0}</span>
              </button>
            ))}
          </div>
        )}
        <div className="flex justify-end gap-2">
          <Button type="button" variant="outline" className="border-slate-700" onClick={onClose} data-testid="stb-print-cancel">Batal</Button>
          <Button type="button" onClick={go} disabled={!picked.length} className="bg-sky-600 hover:bg-sky-500" data-testid="stb-print-go"><Printer className="mr-1.5 h-4 w-4" />Cetak {mode === "partial" ? `PARSIAL (${picked.length} marking)` : "Keseluruhan"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
